// TODO: Remove from `core-js@4`
require('../modules/es.string.match-all');
require('../modules/es.symbol.match-all');
require('../modules/esnext.string.match-all');
